import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=656fb945&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=656fb945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656fb945",
  null
  
)

export default component.exports